import React, { useEffect, useState } from 'react';
import { Alert, Button, Empty, Space, Spin, Tag, Typography } from 'antd';
import SettingsCard from '../../../TrainerSession/SessionSettingsShared/components/SettingsCard';
import DisplayNameEditor from './DisplayNameEditor';
import {
  BlueprintDevPlanName,
  fetchBlueprintDevPlanNames,
  saveBlueprintDevPlanName,
} from './presentationApi';

const BlueprintDisplayNames: React.FC<{ blueprintId: number }> = ({
  blueprintId,
}) => {
  const [items, setItems] = useState<BlueprintDevPlanName[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setItems([]);
    setError('');
    fetchBlueprintDevPlanNames(blueprintId)
      .then(result => {
        if (active) setItems(result.items);
      })
      .catch(reason => {
        if (active) setError(reason.message || 'Could not load display names.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [blueprintId, revision]);
  return (
    <SettingsCard title="Dev Plan display name">
      <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
        <Typography.Text type="secondary">
          Edit how this blueprint appears in each linked plan and node. Names
          can differ between plans; each Save updates only the entry shown.
          Display labels can also be corrected in published plans.
        </Typography.Text>
        <Button
          loading={loading}
          onClick={() => setRevision(value => value + 1)}
        >
          Refresh display names
        </Button>
        {error && <Alert showIcon type="error" title={error} />}
        {loading ? (
          <Spin />
        ) : !error && !items.length ? (
          <Empty description="This blueprint has no Dev Plan entries yet." />
        ) : (
          items.map(item => (
            <div key={`${item.node_id}:${item.position}:${revision}`}>
              <Typography.Text strong>
                {item.plan_name} · {item.node_code}
              </Typography.Text>
              <Typography.Paragraph
                type="secondary"
                style={{ marginBottom: 8 }}
              >
                {item.plan_code} · {item.node_name}{' '}
                <Tag>{item.plan_status}</Tag>
                {(item.plan_hidden || !item.node_active) && <Tag>Hidden</Tag>}
              </Typography.Paragraph>
              <DisplayNameEditor
                label={`display name for ${item.plan_code} ${item.node_code}`}
                value={item.name}
                maxLength={256}
                onSave={async name => {
                  const saved = await saveBlueprintDevPlanName(
                    blueprintId,
                    item,
                    name,
                  );
                  setItems(current =>
                    current.map(row =>
                      row.node_id === saved.node_id &&
                      row.position === saved.position
                        ? saved
                        : row,
                    ),
                  );
                }}
              />
            </div>
          ))
        )}
      </Space>
    </SettingsCard>
  );
};

export default BlueprintDisplayNames;
